module.exports = __webpack_public_path__ + "static/img/tg_postnew.b0dbe882.png";